export const enum MrbItemStatus {
  INCIDENT_NEW = 'NEW',
  CAPA_IN_INVESTIGATION = 'IN_INVESTIGATION',
  CAPA_IN_PLANNING = 'IN_PLANNING',
  FOLLOWUP_SCHEDULED = 'SCHEDULED',
}
